import { FiveSymbolLocale } from '@site-builder/common/src/types/locale';
import cn from 'classnames';
import React from 'react';

import cartIcon from '../../../../../assets/images/icons/cart.svg';
import { getCustomTranslation } from '../../../../../experiments/partnersRequests/utils';
import { analyticsManager } from '../../../../../scripts/afterBlocks/analytics/analytics';
import { AnalyticsActions } from '../../../../../scripts/afterBlocks/analytics/analyticsActions';
import { AnalyticsCategories } from '../../../../../scripts/afterBlocks/analytics/analyticsCategories';
import { SelectorListItem } from '../../../../../types/store/selector-list-item';
import { getAddToCartText } from '../../../../../utils/translation';
import AddToCartSelector from './AddToCartSelector';

export interface ICartButtonProps {
  sku: string;
  locale: FiveSymbolLocale;
  isTextNeeded?: boolean;
  hidden?: boolean;
  addToCart: (sky?: string) => void;
  className?: string;
  selectorList: SelectorListItem[];
  buttonClassPrefix?: string;
  section?: 'pop-up';
  handlerSelect: (value: string | number) => void;
  selectButton?: boolean;
}

const AddToCartButton: React.FC<ICartButtonProps> = ({
  sku,
  locale,
  isTextNeeded,
  hidden,
  addToCart,
  className,
  selectorList,
  buttonClassPrefix,
  section,
  handlerSelect,
  selectButton,
}: ICartButtonProps) => {
  const isShowSelector = selectorList.length > 1;

  const handleClick = () => {
    if (selectButton) {
      analyticsManager.sendEvent({
        category: AnalyticsCategories.STORE,
        event: AnalyticsActions.ADD,
        page: 'landing_store_add-to-cart',
        label: sku,
        section,
      });
      addToCart();
    }
  };

  return (
    <>
      <button
        className={cn(
          'store__buy-btn',
          {
            [`${buttonClassPrefix}__add-to-cart`]: buttonClassPrefix,
          },
          'store__buy-btn--icon',
          { 'store__buy-btn--drm-selector': isShowSelector && !selectButton },
          className
        )}
        onClick={handleClick}
        data-sku={sku}
        data-button-type='add-to-cart'
        hidden={hidden}
      >
        {isTextNeeded && locale && (
          <span className='store__add-to-cart-text'>
            {getAddToCartText(locale)}
          </span>
        )}
        <span
          className='store__cart-button-icon'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: cartIcon }}
        />
        {isShowSelector && (
          <AddToCartSelector
            items={selectorList}
            handlerSelect={handlerSelect}
          />
        )}
      </button>
      {selectButton && (
        <button
          className={cn('store__buy-btn', 'store__buy-btn--icon', {
            'store__buy-btn--drm-selector': isShowSelector && selectButton,
          })}
          hidden
          data-button-type='cart-select'
          data-sku={sku}
        >
          <span
            className='store__in-cart-text'
            data-sku={sku}
            data-type='select-quantity-item-in-cart'
          >
            1
          </span>
          {getCustomTranslation(locale).wb_selector_amount_in_cart}
          {isShowSelector && (
            <AddToCartSelector
              items={selectorList}
              handlerSelect={handlerSelect}
            />
          )}
        </button>
      )}
    </>
  );
};

export default AddToCartButton;
